import React, { useState, useEffect } from 'react';
import axios from 'axios';

const TestAfterPay = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const testAPI = async () => {
      try {
        console.log('🧪 Testando API AfterPay diretamente...');
        
        const api = axios.create({
          baseURL: 'http://localhost:3001',
        });
        
        const response = await api.get('/api/afterpay-reports/stats');
        
        console.log('✅ Resposta da API:', response.data);
        setData(response.data);
        
      } catch (error) {
        console.error('❌ Erro na API:', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    testAPI();
  }, []);

  if (loading) return <div>Carregando teste...</div>;
  if (error) return <div style={{color: 'red'}}>Erro: {error}</div>;

  return (
    <div style={{ padding: '20px' }}>
      <h2>Teste API AfterPay</h2>
      <pre style={{ background: '#f5f5f5', padding: '10px', borderRadius: '5px' }}>
        {JSON.stringify(data, null, 2)}
      </pre>
    </div>
  );
};

export default TestAfterPay;
